export class Alert {

    messageWebID: number;
    messageWebTitle: string;
    messageWebDescription: string;
    startDate: string;
    endDate: string;
    isActive : boolean; 
    fullPath: string;
    
}